import React, { forwardRef, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import Global from '../../../../store/global-selectors';
import { ActionableFilterPill } from '../../index';

const statusDisplayNames = {
  0: <FormattedMessage defaultMessage='Unallocated' description='filterOptions.unallocated' id='sqeP5r' />,
  1: <FormattedMessage defaultMessage='Allocated' description='filterOptions.allocated' id='rlVkKF' />,
  2: <FormattedMessage defaultMessage='Insufficient Inventory' description='filterOptions.insufficientInventory' id='uNJO6/' />,
  3: <FormattedMessage defaultMessage='Has Untracked Ship From' description='filterOptions.hasUntrackedShipFrom' id='5LQtJz' />,
  4: <FormattedMessage defaultMessage='Never Added Inventory' description='filterOptions.neverAddedInventory' id='jZmLsI' />,
  5: <FormattedMessage defaultMessage='System Error' description='filterOptions.systemError' id='fFUhV3' />,
  6: <FormattedMessage defaultMessage='No Tracked Inventory' description='filterOptions.noTrackedInventory' id='/qbNEe' />,
};

const getDisplayName = (appliedStoreFilters) => {
  if (appliedStoreFilters.length === 0) {
    return <FormattedMessage defaultMessage='Allocation Status' description='filterOptions.allocationStatus' id='JbPY93' />;
  }
  if (appliedStoreFilters.length === 1) {
    const [filter] = appliedStoreFilters;
    let key = filter.criterionArgumentValue;
    if (filter.criterionArgumentValue === true) key = 1;
    else if (filter.criterionArgumentValue === false) key = 0;
    return (
      statusDisplayNames[key] || (
        <FormattedMessage defaultMessage='Allocation Status' description='filterOptions.allocationStatus' id='JbPY93' />
      )
    );
  }
  return (
    <FormattedMessage
      defaultMessage='Allocation Status ({count})'
      description='filterOptions.allocationStatusCount'
      id='Fg1ePM'
      values={{ count: appliedStoreFilters.length }}
    />
  );
};

export const AllocationStatus = forwardRef((props, ref) => {
  const appliedFilters = useSelector((state) =>
    Global.selectOrdersFilteringActiveFilterViewFiltersById(state, {
      filterById: props.filterById,
    }),
  );
  const displayContent = useMemo(() => getDisplayName(appliedFilters), [appliedFilters]);
  return <ActionableFilterPill {...props} ref={ref} displayContent={displayContent} isSelected={!!appliedFilters.length} />;
});

AllocationStatus.propTypes = {
  filterById: PropTypes.string,
};
